import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, Route, Switch, withRouter } from 'react-router-dom';

import conceptActions from '../../actions/concepts';
import questionActions from '../../actions/questions';
import { ConceptDetail, Concepts, FillInBlankQuestions, hashToCollection, StaffOnlyWrapper, TabLink, TitleCards } from '../../../Shared';
import FillInBlankQuestion from '../fillInBlank/fillInBlankQuestion.jsx';
import NewFillInBlank from '../fillInBlank/newFillInBlank';
import Lesson from '../lessons/lesson.jsx';
import Lessons from '../lessons/lessons.jsx';
import NewSentenceCombiningQuestion from '../questions/newSentenceCombiningQuestion';
import Question from '../questions/question';
import Questions from '../questions/questions.jsx';
import DiagnosticRouter from '../shared/diagnosticRouter.tsx';
import ShowTitleCard from '../titleCards/showTitleCard.tsx';
import TitleCardForm from '../titleCards/titleCardForm.tsx';

class Admin extends React.Component {
  render() {
    const { concepts, dispatch, fillInBlank, questions, titleCards } = this.props

    const content = (
      <div className="main-admin-container">
        <section className="main-admin-section section is-fullheight">
          <aside className="admin-menu">
            <p className="menu-label">
              General
            </p>
            <ul className="menu-list">
              <TabLink activeClassName="is-active" to='/admin/lessons'>Diagnostics</TabLink>
            </ul>
            <p className="menu-label">
              Questions
            </p>
            <ul className="menu-list">
              <TabLink activeClassName="is-active" to='/admin/questions'>Diagnostic Sentence Combining</TabLink>
              <TabLink activeClassName="is-active" to='/admin/fill-in-the-blanks'>Diagnostic Fill In The Blanks</TabLink>
            </ul>
            <p className="menu-label">
              Supporting
            </p>
            <ul className="menu-list">
              <TabLink activeClassName="is-active" to='/admin/concepts'>Concepts</TabLink>
            </ul>
            <p className="menu-label">
              Title Cards
            </p>
            <ul className="menu-list">
              <TabLink activeClassName="is-active" to='/admin/title-cards'>Title Cards</TabLink>
            </ul>
          </aside>
        </section>
        <Switch>
          <Redirect component={Lessons} exact from='/admin' to='/admin/lessons' />
          <Route
            path='/admin/concepts/:conceptID'
            render={({ match }) => (
              <ConceptDetail
                concepts={concepts}
                containerClassName="admin-container"
                fillInBlank={fillInBlank}
                includeDeleteButton={true}
                includeQuestionForm={true}
                match={match}
                onDeleteConcept={(conceptID) => dispatch(conceptActions.deleteConcept(conceptID))}
                onSubmitNewQuestion={(questionObj, optimalResponseObj) => dispatch(questionActions.submitNewQuestion(questionObj, optimalResponseObj))}
                questions={questions}
                renderLoading={() => <p>Loading...</p>}
                returnLink="/admin/concepts"
              />
            )}
          />
          <Route
            path='/admin/concepts'
            render={() => (
              <Concepts
                concepts={concepts}
                containerClassName="admin-container"
                excludeResponses={false}
                includeNewConceptForm={true}
                onSubmitNewConcept={(conceptName) => {
                  const newConcept = { name: conceptName };
                  dispatch(conceptActions.submitNewConcept(newConcept));
                }}
                renderAsLinks={true}
              />
            )}
          />
          <Route component={Lesson} path='/admin/lessons/:lessonID' />
          <Route component={Lessons} path='/admin/lessons' />
          <Route component={NewSentenceCombiningQuestion} path='/admin/questions/new' />
          <Route component={Question} path='/admin/questions/:questionID' />
          <Route component={Questions} path='/admin/questions' />
          <Route component={TitleCardForm} path='/admin/title-cards/new' />
          <Route component={TitleCardForm} path='/admin/title-cards/:titleCardID/edit' />
          <Route component={ShowTitleCard} path='/admin/title-cards/:titleCardID' />
          <Route path='/admin/title-cards' render={() => <TitleCards titleCards={titleCards} />} />
          <Route component={NewFillInBlank} path='/admin/fill-in-the-blanks/new' />
          <Route component={FillInBlankQuestion} path='/admin/fill-in-the-blanks/:questionID' />
          <Route
            path='/admin/fill-in-the-blanks'
            render={() => {
              const diagnosticQuestions = fillInBlank?.data || {};
              return (
                <FillInBlankQuestions
                  basePath="fill-in-the-blanks"
                  questions={hashToCollection(diagnosticQuestions)}
                  showCreateButton={true}
                  sortQuestions={true}
                />
              );
            }}
          />
          <Route component={DiagnosticRouter} path='/play/diagnostic/:diagnosticID' />
        </Switch>
      </div>
    );

    return <StaffOnlyWrapper>{content}</StaffOnlyWrapper>;
  }
}

function select(state) {
  return {
    concepts: state.concepts,
    fillInBlank: state.fillInBlank,
    questions: state.questions,
    titleCards: state.titleCards
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export default withRouter(connect(select, dispatch => ({dispatch}), mergeProps)(Admin));
